import * as React from "react";
import "./styles.scss";
import { PLAN_LIST_FEATURES } from "../../generated/lib-domain/paymentPlanFeatures";
import { Fragment } from "react";
import {
    PAYMENT_PLANS,
    Subscription
} from "../../generated/lib-domain/paymentPlan";

const PlanList = () => {
    const litePlanName = PAYMENT_PLANS.find(
        (plan) => plan.subscription === Subscription.Lite
    ).title;
    const standardPlanName = PAYMENT_PLANS.find(
        (plan) => plan.subscription === Subscription.Standard
    ).title;
    return (
        <div className="planList">
            <table>
                <caption>有料サービス</caption>
                <thead>
                    <tr>
                        <th></th>
                        <th>無料プラン</th>
                        <th>{litePlanName}</th>
                        <th>{standardPlanName}</th>
                    </tr>
                </thead>
                <tbody>
                    {PLAN_LIST_FEATURES.map((group, index) => {
                        return (
                            <Fragment key={index}>
                                <tr>
                                    <th className="group-name" colSpan={4}>
                                        ■{group.groupName}
                                    </th>
                                </tr>
                                {group.items.map((item) => {
                                    return (
                                        <tr key={item.nameJa}>
                                            <th className="item-name">
                                                {item.nameJa}
                                            </th>
                                            {item.free === "○" ? (
                                                <td className="circle-mark">
                                                    {item.free}
                                                </td>
                                            ) : (
                                                <td className="text">
                                                    {item.free}
                                                </td>
                                            )}
                                            {item.lite === "○" ? (
                                                <td className="circle-mark">
                                                    {item.lite}
                                                </td>
                                            ) : (
                                                <td className="text">
                                                    {item.lite}
                                                </td>
                                            )}
                                            {item.standard === "○" ? (
                                                <td className="circle-mark">
                                                    {item.standard}
                                                </td>
                                            ) : (
                                                <td className="text">
                                                    {item.standard}
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default PlanList;
